import makeForm from '../../../components/Form';
import Yup from '../../../utils/yup';
import { PluviometroFormValues } from '../types';

export const validationSchema = Yup.object().shape({
  descricao: Yup.string().required(),
  propriedade: Yup.object().required(),
  clienteAgrogestao: Yup.boolean().nullable(),
});

export const defaultValues: PluviometroFormValues = {
  descricao: '',
  propriedade: undefined,
  clienteAgrogestao: false,
};

export const PluviometroForm = makeForm<PluviometroFormValues>();
